// @flow

import { connect } from 'react-redux';

import ChallengeInfoModal from 'app/components/challenge/ChallengeInfoModal';
import { fetchGames } from 'app/actions/challengeActions';
import { resetSelectedChallenge } from 'app/actions/lobbyActions';

function mapStateToProps(state: GlobalState) {
  const {
    challenges,
    customChallenges,
    h2hChallenges,
    selectedChallengeId
  } = state.lobbyChallenges;
  const challenge =
    (challenges || [])
      .concat(customChallenges, h2hChallenges)
      .find(c => c.id === selectedChallengeId) || {};

  return {
    bonuses: Object.values(challenge.bonuses),
    cost: challenge.cost,
    countries: challenge.countries,
    entryCap: challenge.entryCap,
    entryCount: challenge.entryCount,
    games: state.lobbyChallenges.selectedGames,
    id: challenge.id,
    isSignedIn: state.user.isSignedIn,
    isTicketChallenge: challenge.isTicketChallenge,
    isRacing: challenge.isRacing,
    isUnlimited: challenge.isUnlimited,
    labels: challenge.labels,
    lang: state.settings.language,
    link: challenge.link,
    maxEntriesPerPerson: challenge.maxEntriesPerPerson,
    name: challenge.name,
    payout: challenge.payout,
    payoutIcon: challenge.payoutIcon,
    payoutMessage: challenge.payoutLongDescription,
    payoutType: challenge.payoutType,
    prizePool: challenge.prizePool,
    reducedCost: challenge.reducedCost,
    scoring: challenge.scoring,
    startTime: challenge.startTime,
    statusId: challenge.statusId,
    statusLabel: challenge.statusLabel
  };
}

const actions = {
  fetchGames,
  onClose: resetSelectedChallenge
};

export default connect(mapStateToProps, actions)(ChallengeInfoModal);
